import { render, staticRenderFns } from "./TgPrompt.vue?vue&type=template&id=24cb1b5d&lang=pug&"
import script from "./TgPrompt.vue?vue&type=script&lang=js&"
export * from "./TgPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports